/* eslint-disable max-len */
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { type GiftVoucherSpecsFragment } from '../../../api/fragments';
import { CustomerKind } from '../../../api/types';
import CollapsibleWrapper, { Panel } from '../../../components/wrappers/CollapsibleWrapper';
import { GroupedCustomerData } from '../../shared/ApplicationDetailsPage/standard/ApplicationTab/ApplicantPanel';
import { RelatedApplicationList } from '../../shared/ApplicationDetailsPage/standard/ApplicationTab/RelatedApplicationPanel';
import AgreementsGrid from '../../shared/CIPage/ConsentAndDeclarations/AgreementsGrid';
import MainDetailsPanel from './panels/MainDetailsPanel';
import VehicleDetailsPanel from './panels/VehicleDetailsPanel';

type InnerProps = {
    voucher: GiftVoucherSpecsFragment;
};

const Inner = ({ voucher }: InnerProps) => {
    const { t } = useTranslation(['giftVoucherDetails', 'giftVoucherList']);

    return (
        <CollapsibleWrapper defaultActiveKey={['mainDetails']}>
            <Panel key="mainDetails" header={t('giftVoucherDetails:cardTitles.details')}>
                <MainDetailsPanel voucher={voucher} />
            </Panel>
            {voucher.application && (
                <Panel key="relatedApplications" header={t('giftVoucherDetails:cardTitles.relatedApplications')}>
                    <RelatedApplicationList application={voucher.application} />
                </Panel>
            )}
            <Panel key="purchaser" header={t('giftVoucherDetails:cardTitles.purchaser')}>
                <Row gutter={14}>
                    <GroupedCustomerData
                        createdAt={voucher.versioning.createdAt}
                        customerKind={CustomerKind.Local}
                        customerType="purchaserData"
                        isMask={voucher.purchaser?.isMaskingCustomerData}
                        kycFieldValues={voucher.purchaserKYC}
                        isDisabled
                    />
                </Row>
            </Panel>
            <Panel key="consents" header={t('giftVoucherDetails:cardTitles.consents')}>
                <AgreementsGrid
                    agreements={voucher.purchaserAgreements}
                    editable={false}
                    prefix="purchaserAgreementsData"
                    disabled
                />
            </Panel>
            <Panel key="vehicle" header={t('giftVoucherDetails:cardTitles.vehicle')}>
                <VehicleDetailsPanel voucher={voucher} />
            </Panel>
        </CollapsibleWrapper>
    );
};

export default Inner;
